import styled, { css } from 'styled-components';
import { palette, ToastContainer } from '@m12s/component-library';

const NotificationToast = css`
  .mm-notification-toast {
    box-shadow: none;

    & .Toastify__toast-body {
      display: flex;
      justify-content: center;
      overflow: hidden;
      white-space: nowrap;

      [class^='Notification__Wrapper'] {
        border-radius: 0.25rem;
        text-align: center;
        background: ${palette.Grey800};
        min-height: unset;
        padding: 0;
        height: 3rem;
        width: auto;

        & [class^='Notification__TextWrapper'] {
          padding: 0;
          margin: 0;
          width: auto;
          max-width: 30rem !important;
        }
      }
    }

    &.error {
      [class^='Notification__Wrapper'] {
        background: ${palette.Red600};
      }
    }

    &.critical-error {
      [class^='Notification__Wrapper'] {
        background: ${palette.Red600};
      }

      & .Toastify__toast-body {
        white-space: normal;
        overflow: visible;

        [class^='Notification__Wrapper'] {
          height: auto;
          min-height: 3rem;
          padding: 0.5rem 0;
        }
      }
    }
  }
`;

const CustomToastContainer = styled(ToastContainer)`
  &.Toastify__toast-container--bottom-center {
    min-width: 30rem !important;
    left: 50% !important;
    margin-left: -15rem !important;
  }

  ${NotificationToast}
`;

const PreWrap = styled.span`
  font-weight: 400;
  color: ${palette.White};
  font-size: 1rem;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 1rem;
`;

const FullWrap = styled.span`
  font-weight: 400;
  color: ${palette.White};
  font-size: 1rem;
  display: block;
  white-space: normal;
  word-break: break-word;
  padding: 0 1rem;
`;

export { CustomToastContainer, PreWrap, FullWrap };
